<template>
  <rich-text-field-base v-bind="$attrs" ref="field" :field-layout-component="fieldLayoutComponent" />
</template>

<script>
import RichTextFieldBase from '@/campaign-form-shared/rich-text-field'
import TextFieldMixin from './text-field-mixin'

export default {
  components: { RichTextFieldBase },

  mixins: [TextFieldMixin]
}
</script>
